import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

export default function useCountdownTimer(options?: { spacing?: boolean }) {
  const spacing = options?.spacing ?? true;

  const [timeUntilMidnight, setTimeUntilMidnight] = useState('');

  useEffect(() => {
    const updateCountdown = () => {
      // Get the current time
      const now = dayjs();

      // Calculate the time until midnight
      const midnight = now.endOf('day');
      const timeDiff = midnight.diff(now);

      // Extract hours, minutes, and seconds from the time difference
      const hours = Math.floor(timeDiff / 3600000); // 1 hour = 3600000 milliseconds
      const minutes = Math.floor((timeDiff % 3600000) / 60000); // 1 minute = 60000 milliseconds
      const seconds = Math.floor((timeDiff % 60000) / 1000); // 1 second = 1000 milliseconds

      // Format the result
      const result = `${String(hours).padStart(2, '0')}${spacing ? ' ' : ''}:${
        spacing ? ' ' : ''
      }${String(minutes).padStart(2, '0')}${spacing ? ' ' : ''}:${
        spacing ? ' ' : ''
      }${String(seconds).padStart(2, '0')}`;

      // Update the state with the new result
      setTimeUntilMidnight(result);
    };

    // Call the updateCountdown immediately
    updateCountdown();

    // Update the countdown every second
    const intervalId = setInterval(updateCountdown, 1000);

    // Clean up the interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  return timeUntilMidnight;
}
